import React from 'react';

const InputField = ({ value, onChange, onKeyDown, onFocus, onBlur, placeholder = "0", className = "", readOnly = false, ...props }) => {
  return (
    <input 
      type="number" 
      min="0"
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      onFocus={onFocus}
      onBlur={onBlur}
      placeholder={placeholder}
      className={className}
      readOnly={readOnly}
      {...props}
    />
  );
};

export default InputField;